import { z } from 'zod';
import { isValidPhoneNumber } from 'react-phone-number-input';

import { NAME_REGEX, PASSWORD_REGEX } from './regex';

export const nameSchemaReq = z
  .string()
  .min(1, { message: '' })
  .max(50, { message: 'Name cannot exceed 50 characters!' })
  .regex(NAME_REGEX, { message: 'Invalid characters!' });

export const nameSchemaOpt = z
  .string()
  .max(50, { message: 'Name cannot exceed 50 characters!' })
  .regex(NAME_REGEX, { message: 'Invalid characters!' })
  .nullable();

export const passwordSchemaReq = z
  .string()
  .min(1, { message: '' })
  .min(8, { message: '' })
  .max(50, { message: 'Password cannot exceed 50 characters!' })
  .regex(PASSWORD_REGEX, { message: '' });

export const emailSchemaReq = z
  .string()
  .min(1, { message: '' })
  .max(100, { message: 'Email cannot exceed 100 characters!' })
  .email({ message: '' });

export const phoneSchemaOpt = z
  .string()
  .transform((val) => val ?? null)
  .refine((val) => val === null || val === '' || isValidPhoneNumber(val), {
    message: 'Invalid phone number!',
  });
